import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CompanyBranchEntity } from '../../domain/entities/CompanyBranchEntity'

export class CompanyBranchModel extends CompanyBranchEntity {
  constructor(dataDto: CompanyBranchEntity) {
    super()
    mapEntityProperties<CompanyBranchEntity>(this, dataDto)
  }
}
